// Core Imports
import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import DateFormat from 'dateformat';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import store from "./store";

// Import the Auth0 configuration, and the plugin
import { domain, clientId, audience } from "../auth_config.json";
import { Auth0Plugin } from "./auth";
import { authGuard } from "./auth/authGuard"; //  use the guard to protect the page

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.use(VueRouter);
Vue.use(VueAxios, Axios);
Vue.use(VeeValidate);


// Page Imports
import Invoices from './pages/Invoices.vue';
import Home from './pages/Home.vue';
import Contact from './pages/Contact.vue';
import Calls from './pages/Calls.vue';
import Mails from './pages/Mails.vue';
import Reservations from './pages/Reservations.vue';
import Desks from './pages/Desks.vue';
import Subscriptions from './pages/Subscriptions.vue';

// Layout Imports
import LeftMenu from './components/LeftMenu.vue';

const routes = [
    { path: '/', component: Home },    
    // use "beforeEnter : authGuard" to protect the pages from being accessed
    // if the user is not logged in.
    { path: '/features/invoices', component: Invoices, beforeEnter : authGuard },
    { path: '/features/contact', component: Contact, beforeEnter : authGuard },
    { path: '/features/calls', component: Calls, beforeEnter : authGuard },
    { path: '/features/mails', component: Mails, beforeEnter : authGuard },
    { path: '/features/reservations', component: Reservations, beforeEnter : authGuard },
    { path: '/features/desks', component: Desks, beforeEnter : authGuard },
    { path: '/features/subscriptions', component: Subscriptions, beforeEnter : authGuard }
];

const router = new VueRouter({
    routes // short for `routes: routes`
});

const app = new Vue({
    router,
    store,
    Auth0Plugin,
    //el: '#app',
    //data: {
    //    currentRoute: window.location.hash
    //},
    components: { LeftMenu },
    template: `
    <div id="app">
        <!-- start: sidebar -->
        <LeftMenu />
        <!-- end: sidebar -->

        <section role="main" class="content-body">
            <header class="page-header">
            
            </header>
      
          <div>
            <router-view class="view"></router-view>
          </div>
      
          <div class="center-sign">
            <p class="text-center text-muted mt-md mb-md">
              &copy;  Derechos Reservados 2018 CuatroTorres.
            </p>
          </div>
        </section>
    </div>
  `
    //computed: {
    //    ViewComponent () {
    //        var self = this;
    //        var matchRoute = routes.filter(function(route){
    //            console.log(route);
    //            return route.path === self.currentRoute.replace('#','');
    //        })

    //        console.log(matchRoute);

    //        if(typeof(matchRoute) !== 'undefined')
    //            return matchRoute[0].component;

    //        return NotFound;

    //        //var findPath = this.currentRoute.replace('#','');
    //        //console.log(findPath)
    //        //var view = routes[findPath] || NotFound
    //        //console.log(routes)
    //        //return view
    //        //const matchingView = routes[this.currentRoute];
    //        //return matchingView
    //        //    ? require('./' + matchingView + '.vue')
    //        //    : require('./NotFound.vue')
    //    }
    //},
    //render (h) { 
    //    return h(this.ViewComponent) 
    //}
}).$mount('#app');

//window.addEventListener('popstate', () => {
//    app.currentRoute = window.location.hash
//})